var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_193_18894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12093 30.6379C2.39113 29.2321 2.57665 28.6614 2.95616 27.7101L24.9544 25.3853C25.8046 26.3775 25.9422 27.0674 25.2546 28.2598C17.6822 31.4895 10.5174 32.0974 3.12093 30.6379Z",
    fill: "#C67C54",
    stroke: "#231F20",
    strokeWidth: 1.06,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00534 4.6005C1.65958 9.14848 4.47991 13.3447 8.45325 15.6602C6.68296 17.2896 4.87867 18.9826 3.81254 21.1362C2.74641 23.2897 2.54246 26.0425 3.9206 28.0181C8.63205 28.835 14.8407 28.2098 21.8483 26.8135C22.7552 26.6347 23.6961 26.3923 24.3009 25.6903C25.0304 24.8254 25.0236 22.7965 22.86 19.7721C20.6965 16.7477 16.6277 14.7932 16.6277 14.7932C16.6277 14.7932 22.4887 9.98199 21.9657 0.698942C15.2638 2.03534 8.48123 2.95759 1.66695 3.4509",
    fill: "#D9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00534 4.6005C1.65958 9.14848 4.47991 13.3447 8.45325 15.6602C6.68296 17.2896 4.87867 18.9826 3.81254 21.1362C2.74641 23.2897 2.54246 26.0425 3.9206 28.0181C8.63205 28.835 14.8407 28.2098 21.8483 26.8135C22.7552 26.6347 23.6961 26.3923 24.3009 25.6903C25.0304 24.8254 25.0236 22.7965 22.86 19.7721C20.6965 16.7477 16.6277 14.7932 16.6277 14.7932C16.6277 14.7932 22.4887 9.98199 21.9657 0.698942C15.2638 2.03534 8.48123 2.95759 1.66695 3.4509",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9762 0.0847773C22.7609 1.84698 23.2478 1.689 22.8688 2.85124C15.3509 4.16668 7.76369 4.97646 0.0990764 5.30146C-0.806255 4.05339 -0.823715 3.87424 -0.132459 2.41028C7.90615 0.561823 14.5116 0.40033 21.9862 0.0838073L21.9762 0.0847773Z",
    fill: "#C67C54",
    stroke: "#231F20",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6172 20.5491C9.90003 20.8139 6.0202 25.231 6.02357 25.4718C8.63194 27.6993 16.8693 26.3439 21.9139 24.0839C21.9139 24.0839 15.3353 20.2942 12.6181 20.559L12.6172 20.5491Z",
    fill: "#CEBC82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9951 15.4587C14.8608 14.2922 18.3916 11.7578 18.6261 9.52449C15.1847 8.54368 7.2885 8.76063 5.35335 10.6573C7.09995 12.9085 9.3603 14.2455 11.7853 15.4158L12.9951 15.4587Z",
    fill: "#CEBC82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_193_18894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1,
    height: 31.82,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.b3662d32438d16155872fcf458503502.svg";
export { ForwardRef as ReactComponent };